var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 21,
    fill: "none",
    viewBox: "0 0 28 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.032 3.632h-3.748l-.927-1.855C18.816.695 17.734 0 16.497 0h-5.833c-1.198 0-2.319.657-2.86 1.777l-.927 1.855H3.168C1.43 3.632 0 5.062 0 6.8v10.895c0 1.74 1.43 3.169 3.168 3.169h20.864c1.738 0 3.168-1.43 3.168-3.169V6.84c0-1.778-1.43-3.207-3.168-3.207zM13.6 18.12c-3.477 0-6.298-2.898-6.298-6.453 0-3.554 2.82-6.49 6.298-6.49 3.477 0 6.298 2.897 6.298 6.452 0 3.554-2.82 6.49-6.298 6.49z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.6 6.723c-2.627 0-4.752 2.202-4.752 4.907 0 2.704 2.125 4.945 4.752 4.945s4.752-2.202 4.752-4.907c0-2.704-2.125-4.945-4.752-4.945zm0 7.997c-1.661 0-2.975-1.39-2.975-3.052 0-1.661 1.352-3.052 2.975-3.052s2.975 1.39 2.975 3.052c0 1.662-1.314 3.053-2.975 3.053z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.521cd978dedb7d0a209f3231db9df781.svg";
export { ForwardRef as ReactComponent };